module.exports = __webpack_public_path__ + "img/index.e5d8bdf0.png";